"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var cdnVersion = "1.0.225";
var cdnUrl = "https://ncontracts-cdn.ncontracts.com/".concat(cdnVersion);
var iconPath = "".concat(cdnUrl, "/icons");
var _default = {
  iconPath: iconPath,
  icons: {
    arrow: "".concat(iconPath, "/arrow.svg"),
    caretDown: "".concat(iconPath, "/caret-down-grey.svg"),
    threeDots: "".concat(iconPath, "/3-dots.svg")
  },
  logos: "".concat(cdnUrl, "/logos")
};
exports["default"] = _default;